// src/components/Shared/GlobalInAppNotification.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoNotifications, IoClose, IoChevronForward } from 'react-icons/io5';

export default function GlobalInAppNotification() {
  const [notification, setNotification] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleNotification = (e) => {
      const { title, body, data } = e.detail || {};
      if (!title && !body) return;

      setNotification({
        title: title || 'Acceso Detectado',
        body: body || '',
        data: data || {},
        id: Date.now()
      });
    };

    window.addEventListener('kondo_inapp_notification', handleNotification);
    return () => window.removeEventListener('kondo_inapp_notification', handleNotification);
  }, []);

  useEffect(() => {
    if (!notification) return;
    const timer = setTimeout(() => {
      setNotification(null);
    }, 6500);
    return () => clearTimeout(timer);
  }, [notification]);

  if (!notification) return null;

  const handleClick = () => {
    const data = notification.data || {};
    if (data.type === 'access_entry') {
      navigate('/bitacora');
    } else if (data.url) {
      navigate(data.url);
    } else {
      navigate('/accesos');
    }
    setNotification(null);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 'env(safe-area-inset-top, 14px)',
        marginTop: '12px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'calc(100% - 28px)',
        maxWidth: '430px',
        zIndex: 999999,
        background: 'linear-gradient(135deg, rgba(28, 22, 54, 0.96) 0%, rgba(18, 14, 38, 0.96) 100%)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(139, 92, 246, 0.35)',
        boxShadow: '0 20px 40px -8px rgba(15, 10, 35, 0.65), 0 0 20px rgba(124, 58, 237, 0.25)',
        borderRadius: '20px',
        padding: '14px 16px',
        color: '#FFFFFF',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        cursor: 'pointer',
        animation: 'kondoSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards',
        fontFamily: 'inherit'
      }}
      onClick={handleClick}
    >
      <style>{`
        @keyframes kondoSlideIn {
          from {
            opacity: 0;
            transform: translate(-50%, -24px) scale(0.96);
          }
          to {
            opacity: 1;
            transform: translate(-50%, 0) scale(1);
          }
        }
      `}</style>

      {/* Glow Accent Circle */}
      <div
        style={{
          width: '42px',
          height: '42px',
          borderRadius: '14px',
          background: 'linear-gradient(135deg, #7C3AED 0%, #4F46E5 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          boxShadow: '0 4px 12px rgba(124, 58, 237, 0.4)'
        }}
      >
        <IoNotifications size={22} color="#FFFFFF" />
      </div>

      {/* Content Area */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.6px',
            textTransform: 'uppercase',
            color: '#A78BFA',
            marginBottom: '2px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          <span>KONDIFY ACCESOS</span>
          <span style={{ fontSize: '9px', opacity: 0.7 }}>• ahora</span>
        </div>
        <div
          style={{
            fontSize: '14px',
            fontWeight: 700,
            color: '#FFFFFF',
            lineHeight: 1.25,
            marginBottom: '3px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {notification.title}
        </div>
        <div
          style={{
            fontSize: '12.5px',
            fontWeight: 400,
            color: '#E2E8F0',
            lineHeight: 1.35,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          }}
        >
          {notification.body}
        </div>
      </div>

      {/* Right chevron and close button */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          flexShrink: 0
        }}
      >
        <div
          style={{
            padding: '6px',
            borderRadius: '10px',
            color: 'rgba(255, 255, 255, 0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <IoChevronForward size={18} />
        </div>
        <button
          style={{
            background: 'rgba(255, 255, 255, 0.1)',
            border: 'none',
            borderRadius: '50%',
            width: '26px',
            height: '26px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
            cursor: 'pointer',
            padding: 0
          }}
          onClick={(e) => {
            e.stopPropagation();
            setNotification(null);
          }}
          aria-label="Cerrar notificación"
        >
          <IoClose size={16} />
        </button>
      </div>
    </div>
  );
}
